<template>
	<div style="margin: 10px;">
		<el-row>
			<el-col :spa="24">
				<el-card class="box-card">
					<h4 class="title">参数信息</h4>
					<el-form ref="form" :model="form" label-width="120px" :rules="rules">

						<el-form-item label="栏目名称" prop="title">
							<el-input v-model="form.title" style="width: 30%;"></el-input>
						</el-form-item>
						<el-form-item label="排列顺序" prop="sorts">
							<el-input v-model="form.sorts" style="width: 30%;"></el-input>
						</el-form-item>
						<el-form-item label="导航显示" prop="show">
							<el-radio-group v-model="form.show">
								<el-radio :label="1" value="1">都显示</el-radio>
								<el-radio :label="2" value="2">头部显示</el-radio>
								<el-radio :label="3" value="3">底部显示</el-radio>
								<el-radio :label="0" value="0">不显示</el-radio>
							</el-radio-group>
						</el-form-item>
						<el-form-item label="首页显示" prop="index">
							<el-radio-group v-model="form.index">
								<el-radio :label="1" value="1">显示</el-radio>
								<el-radio :label="0" value="0">不显示</el-radio>
							</el-radio-group>
						</el-form-item>
						<el-form-item label="图片路径" :prop="picS == 1 ? 'pic' :''">
							<!-- <el-input v-model="form.pic" style="width:20%;float: left;" readonly></el-input> -->
							<el-upload drag  list-type="picture-card" action="" :on-preview="handlePreview"
							 multiple :limit="1" :on-success="getUrl" :on-exceed="handleLogo" :file-list="fileList"  :before-upload="beforePic" style="width:auto;float: left;">
								<i class="el-icon-picture-outline"></i>
								<br />
								<span class="uploadTip">将图片拖到此处，或点击上传</span>
							</el-upload>
							<input type="button" size="mini" class="bullet" style="display: inline-block;margin-top:5px;float: left;" @click.stop="picBook = 1,dialogVisible = true"
							 value="素材库选择">
						</el-form-item>
						<h4 class="title">栏目简介</h4>
						<el-form-item label="">
							<editor v-model="form.detail" :isClear="isClear" @change="change"></editor>
						</el-form-item>

						<el-form-item>
							<input type="button" @click="onSubmit" class="submit" value="提交">
						</el-form-item>
					</el-form>
				</el-card>
			</el-col>
		</el-row>
		<!-- 素材库选择 -->
		<el-dialog title="素材库选择" :visible.sync="dialogVisible" width="50%" >
			<files @selectPic ="selectPic"></files>
		</el-dialog>
	</div>
</template>

<script>
	import request from '../../../assets/js/request.js'
	import qs from 'qs'
import E from "wangeditor";
	import Editor from '../../../components/tinymce.vue'
	import files from '../../../components/picFile.vue'
	
	export default {
		components: {
			files,
			Editor
		},
		data() {
			return {
				form: {
					sorts: '',
					title: '',
					show: '',
					pic: '',
					detail:'',
					index:'',
				},
				editorText:'',
				picS:1,
				isClear: false,
				rules: {
					pic: [{
						required: true,
						message: '请输入图片',
						trigger: 'blur'
					}],
					title: [{
						required: true,
						message: '请输入名称',
						trigger: 'blur'
					}],
					sorts: [{
						required: true,
						message: '请输入排列顺序',
						trigger: 'blur'
					}],
					show: [{
						required: true,
						message: '请选择导航显示',
						trigger: 'blur'
					}],
					index: [{
						required: true,
						message: '请选择是否首页显示',
						trigger: 'blur'
					}],
				},
				fileList: [],
				dialogVisible:false
			}
		},
		created() {
			if (this.$route.query.iden == 'update') {
				console.log(this.$route.query.rows)
				this.form.pic = this.$route.query.rows.images
				if(this.$route.query.rows.images == ''){
					this.fileList=[]
				}else{
					this.fileList.push({url:this.settings.apiBaseImg+this.$route.query.rows.images})
				}
				this.form.title = this.$route.query.rows.columname
				this.form.sorts = this.$route.query.rows.order
				this.form.show = this.$route.query.rows.display
				this.form.index = this.$route.query.rows.index
				this.form.detail = this.$route.query.rows.brief
				this.picS = 2
			}
		},
		methods: {
			//添加提交
			onSubmit() {
				var obj = this;
				obj.$http({
					method: 'post',
					url: 'api/v1/column/update',
					data: {
						id: this.$route.query.rows.id,
						order: this.form.sorts,
						columname: this.form.title,
						display: this.form.show,
						index:this.form.index,
						images: this.form.pic,
						brief: this.form.detail,
						uid: localStorage.getItem('uid')
					},
				}).then((res) => {
					if (res.data.status == 200) {
						obj.$message.success('修改成功')
						this.$router.push({
							path:'/home/column'
						})
					} else {
						obj.$message.error(res.data.message)
					}
				})
			},
			change(val) {
				console.log(val)
			},
			getUrl(file, fileList) {
				this.form.pic = file.data.fileName
			},
			selectPic(index, rows) {
				this.fileList=[]
				this.fileList.push({url:this.settings.apiBaseImg+rows.path})
					this.form.pic = rows.path
					this.dialogVisible = false
				
			},
			handlePreview(file) {
				console.log(file);
			},
			RemovePic() {
				this.form.pic = ''
			},
			handleLogo(files, fileList) {
				this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
			},
			//上传图片之前调取接口
			beforePic(file, fileList) {
				let objUrl = file;
				let formData = new FormData();
				formData.append('file', objUrl);
				formData.append('uid', localStorage.getItem('uid'));
				var obj = this;
				obj.$http({
					method: 'post',
					url: 'api/v1/common/upload',
					data: formData,
				}).then((res) => {
					if (res.status == 200) {
					this.fileList=[]
					this.fileList.push({url:this.settings.apiBaseImg+res.data.data.fileName})
						this.form.pic = res.data.data.fileName
						obj.$message.success(res.data.message)
					} else {
						obj.$message.error(res.data.message)
					}
				})
			},
		}
	}
</script>

<style scoped="scoped">
	.title {
		margin-bottom: 40px;
	}

	/deep/ .el-input__inner {
		height: 30px;
	}

	.picTip {

		height: 16px;
		font-size: 14px;
		font-family: PingFang SC;
		font-weight: 400;
		color: #000000;
		line-height: 24px;
		opacity: 0.5;
		margin-left: 10px;
	}
</style>



// WEBPACK FOOTER //
// src/views/system/column/columnAdd.vue